/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2025-11-20 14:03:09
 * @LastEditTime: 2025-11-28 14:24:27
 */
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Cascader, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Result, Row, Upload, message, notification } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { areaOptions } from '../../../data/city';
import { getEnv } from '../../../helpers/mobx-easy-wrapper';
import qrImg from '../../../images/qr.jpg';

const College = () => {
  const [form] = Form.useForm();
  const [detail, setDetail] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [resultIcon, setResultIcon] = useState('');
  const [status, setStatus] = useState(-1);
  const [availableStatus, setAvailableStatus] = useState(0);
  const [orgFieldValue, setOrgFieldValue] = useState('');

  const [countdown, setCountdown] = useState('');
  const [businessPlanUrl, setBusinessPlanUrl] = useState('');
  const [defaultFileList, setDefaultFileList] = useState([]);

  const [otherMaterialsUrl, setOtherMaterialsUrl] = useState('');
  const [materialDefaultFileList, setMaterialDefaultFileList] = useState([]);

  const [commitUrl, setCommitUrl] = useState('');
  const [commitDefaultFileList, setCommitDefaultFileList] = useState([]);

  const [patentLicenseUrl, setPatentLicenseUrl] = useState('');
  const [patentLicenseDefaultFileList, setPatentLicenseDefaultFileList] = useState([]);

  const [orgLicenseUrl, setOrgLicenseUrl] = useState('');
  const [orgLicenseDefaultFileList, setOrgLicenseDefaultFileList] = useState([]);

  const [customInputState, setCustomInputState] = useState(true);
  const [uploaded, setUploaded] = useState(false);

  const [convertState, setConvertState] = useState(-1);

  const { apiFactory } = getEnv();

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };

  const onFinish = (values: any) => {
    //console.log("Received values of form: ", values);
  };

  function beforeUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 50;
    if (!isLt2M) {
      message.error('文件大小必须小于50mb!');
    }
    return isLt2M;
  }

  const handleUpload = async (option: any, key: any, setVal: any, setArray: any) => {
    const file = option.file as File;
    try {
      const result = await apiFactory.techService.upload(file);
      
      if (result.status && result.status === 200) {
        const tempUrlArray = key.length == 0 ? [] : key.split(',');

        tempUrlArray.push(result.data.downloadUrl);
        setVal(tempUrlArray.join(','));
        option.onSuccess(result.url);
      } else {
        message.error('文件上传失败');
      }
    } catch (error) {
      message.error('文件上传失败');
      option.onError(error);
    }
  };

  function showTip() {
    notification.info({
      message: `报名未开始 `,
      description: countdown,
      placement: 'top',
    });
  }

  function countTime() {
    //获取当前时间
    var date = new Date();
    var now = date.getTime();
    //设置截止时间
    // var str = '2022/5/10 14:30:00';
    var str = '2023/5/10 14:30:00';
    var endDate = new Date(str);
    var end = endDate.getTime();

    //时间差
    var leftTime = end - now;
    //定义变量 d,h,m,s保存倒计时的时间
    var d, h, m, s;
    if (leftTime >= 0) {
      d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
      h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
      m = Math.floor((leftTime / 1000 / 60) % 60);
      s = Math.floor((leftTime / 1000) % 60);
    }
    //将0-9的数字前面加上0，例1变为01
    d = checkTime(d);
    h = checkTime(h);
    m = checkTime(m);
    s = checkTime(s);
    function checkTime(i: any) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    }
    // console.log()
    setCountdown(`距离报名时间还有${d}天${h}时${m}分`);
    //递归每秒调用countTime方法，显示动态时间效果
    setTimeout(countTime, 1000);
  }

  useEffect(() => {
    async function checkAvailable() {
      const checkData = await apiFactory.techService.checkAvailble();
      if (checkData.status == 0) {
        // getDetail();
      } else {
        if (status === -1) {
          setErrorMsg(checkData.msg);
        }
        setResultIcon('error');
        setAvailableStatus(checkData.status);
      }
      getDetail();
    }
    async function getDetail() {
      if (!apiFactory.authService.isAuthenticated()) {
        message.error('用户未登录，请先登录');
        return;
      }
      const result = await apiFactory.activityService.getWorksDetail();
      // debugger
      if (result.status &&result.status == 401) {
        message.error('用户未登录，请先登录');
        (document.getElementById('loginHeader') as HTMLDivElement).click();
        return;
      }
      if (result && result.groupType === '初创') {
        result.orgName && (result.orgName = result.orgName.split(','));
        result.orgType && (result.orgType = result.orgType.split(','));
        result.patentApplyDate && (result.patentApplyDate = moment(result.patentApplyDate));
        if (result.patents && Array.isArray(result.patents)) {
          result.patents = result.patents.map((p: any) => {
            if (p.applyDate && typeof p.applyDate === 'string') {
              p.applyDate = moment(p.applyDate);
            }
            return p;
          });
        }
        if (result.proField) {
          const dataSet = [
            '数字经济',
            '生物经济',
            '冰雪经济',
            '创意设计',
            '航空航天',
            '电子信息',
            '新材料',
            '高端装备',
            '信息通信',
            '农机装备',
            '能源',
            '化工',
            '食品',
            '医药',
          ];
          if (dataSet.indexOf(result.proField) > -1) {
            setCustomInputState(true);
          } else {
            setOrgFieldValue(result.proField);
            result.proField = 'custom';
            // 设置自定义输入框不可用
            setCustomInputState(false);
          }
        }

        result.orgCategory && (result.orgCategory = result.orgCategory.split(','));
        // if (result.patentNo) {
        //   const patentsArray = [] as any;
        //   result.patentNo.split(',').forEach((item: string, index: number) => {
        //     const pName = result.patentName ? result.patentName.split(',')[index] : '';
        //     const pUser = result.patentOwner ? result.patentOwner.split(',')[index] : '';
        //     const pType = result.patentType ? result.patentType.split(',')[index] : '';
        //     const pct = result.applyPct ? result.applyPct.split(',')[index] : '';
        //     const validYear = result.patentValidYear ? result.patentValidYear.split(',')[index] : '';
        //     patentsArray.push({
        //       no: item,
        //       name: pName,
        //       users: pUser,
        //       type: pType,
        //       validYear,
        //       pct,
        //     });
        //   });
        //   result.patents = patentsArray;
        // }
        if (result.businessPlanUrl && result.businessPlanUrl.startsWith(',')) {
          result.businessPlanUrl = result.businessPlanUrl.replace(',', '');
        }
        if (result.businessPlanUrl) {
          setUploaded(true);
          // 填充文件名
          const fileList = [] as any[];
          result.businessPlanUrl.split(',').forEach((url: string, i: number) => {
          const temp = url.split('/');
          const fileName = temp[temp.length - 1];
          fileList.push({
            uid: i,
            name: fileName,
            status: 'done',
            url: url,
          });
        });
          setDefaultFileList(fileList);
          console.log(88888,fileList);
          

          setBusinessPlanUrl(result.businessPlanUrl);
        }
        if (result.otherMaterialsUrl) {
          setUploaded(true);
          const fileList = [] as any[];
          result.otherMaterialsUrl.split(',').forEach((url: string, i: number) => {
            const temp = url.split('/');
            const fileName = temp[temp.length - 1];
            fileList.push({
              uid: 'material_' + i,
              name: fileName,
              status: 'done',
              url: url,
            });
          });
          setMaterialDefaultFileList(fileList);
          setOtherMaterialsUrl(result.otherMaterialsUrl);
        }

        if (result.patentLicenseUrl) {
          setUploaded(true);
          const fileList = [] as any[];
          result.patentLicenseUrl.split(',').forEach((url: string, i: number) => {
            const temp = url.split('/');
            const fileName = temp[temp.length - 1];
            fileList.push({
              uid: 'patentLicense_' + i,
              name: fileName,
              status: 'done',
              url: url,
            });
          });
          setPatentLicenseDefaultFileList(fileList);
          setPatentLicenseUrl(result.patentLicenseUrl);
        }

        if (result.commitUrl) {
          setUploaded(true);
          const fileList = [] as any[];
          result.commitUrl.split(',').forEach((url: string, i: number) => {
            const temp = url.split('/');
            const fileName = temp[temp.length - 1];
            fileList.push({
              uid: 'commit_' + i,
              name: fileName,
              status: 'done',
              url: url,
            });
          });
          setCommitDefaultFileList(fileList);
          setCommitUrl(result.commitUrl);
        }

        if (result.orgLicenseUrl) {
          setUploaded(true);
          const fileList = [] as any[];
          result.orgLicenseUrl.split(',').forEach((url: string, i: number) => {
            const temp = url.split('/');
            const fileName = temp[temp.length - 1];
            fileList.push({
              uid: 'orgLicense_' + i,
              name: fileName,
              status: 'done',
              url: url,
            });
          });
          setOrgLicenseDefaultFileList(fileList);
          setOrgLicenseUrl(result.orgLicenseUrl);
        }

        console.log(result);

        form.setFieldsValue(result);
        switch (result.status) {
          case 0:
            setResultIcon('info');
            setErrorMsg(
              (result.creator?.name || '') +
                '您申报的项目' +
                result.worksName +
                '报名成功！'
            );
            break;
          case 1:
            setResultIcon('error');
            setErrorMsg(`很抱歉您未通过审核，失败的理由为：${result.failReason}`);
            break;
          case 2:
            setResultIcon('success');
            setErrorMsg('您已通过审核，现阶段进入专家评分阶段');
            break;
          default:
            setResultIcon('success');
            setErrorMsg('您已通过审核，现阶段进入专家评分阶段。');
            break;
        }
        setStatus(result.status);
        /*if (result.status === 1) {
                          setErrorMsg(result.failReason);
                        }*/
        setDetail(result);
      }
      /*   else if(result ) {
                    setStatus(result.status)
                  }*/
      // console.log(result);
    }
    checkAvailable();

    countTime();
  }, []);

  const patentRemove = (index: number) => {
    // 1. 先拿到当前整个 patents 数组
    const curr = form.getFieldValue('patents') || [];

    // 2. 删掉指定行
    const next = curr.filter((_: any, idx: number) => idx !== index);

    // 3. 把处理后的数组写回，触发视图更新
    form.setFieldsValue({ patents: next });
  };
  const changeCustomInput = (event: any) => {
    console.log(event.target.value);
    if (event.target.value.indexOf('custom') > -1) {
      setCustomInputState(false);
    } else {
      setCustomInputState(true);
    }
  };


  const removeUploadFile = (file: any, key: any, setVal: any) => {
    const tempArray = key.split(',');
    tempArray.forEach((item: any, index: any) => {
      item.endsWith(file.name);
      tempArray.splice(index, 1);
    });
    setVal(tempArray.join(','));
  };

  const submitForm = async () => {
    console.log(333, form.getFieldsValue(),businessPlanUrl);

    //form.submit();
    if (!apiFactory.authService.isAuthenticated()) {
      message.error('用户未登录，请先登录');
      return;
    }
    if ((window as any)['enterStatus'] === 2) {
      message.error('您的企业报名已审核成功，无需再次报名！');
      return;
    }
    try {
      const values = await form.validateFields();
    } catch (e) {
      console.log(99999,e);
      
      return;
    }

    // console.log("Success:", values);
    const formData = form.getFieldsValue();

    if (
      !businessPlanUrl ||
      !commitUrl ||
      !patentLicenseUrl ||
      (formData.patents.length <= 0) ||
      (!formData.techInfo ||
        !formData.teamInfo ||
        !formData.marketInfo ||
        !formData.patentLayoutInfo ||
        !formData.socialImpactInfo)
    ) {
      message.warn('请填写项目基本信息或者上传附件');
      return;
    }

    const patentNoArray = [];
    const patentNameArray = [];
    const patentUsersArray = [];
    const patentTypeArray = [];
    const patentPctArray = [];
    const patentValidYearArray = [];

    for (const patent of formData.patents) {
      patentNoArray.push(patent.no);
      patentNameArray.push(patent.name);
      patentUsersArray.push(patent.users);
      patentTypeArray.push(patent.type);
      patentPctArray.push(patent.pct);
      patentValidYearArray.push(patent.validYear);
    }
    formData.year = '2025';
    formData.groupType = '初创';
    // formData.patentNo = patentNoArray.join(',');
    // formData.patentName = patentNameArray.join(',');
    // formData.patentOwner = patentUsersArray.join(',');
    // formData.patentType = patentTypeArray.join(',');
    // formData.applyPct = patentPctArray.join(',');
    // formData.patentValidYear = patentValidYearArray.join(',');
    formData.orgName && (formData.orgName = formData.orgName.join(','));
    formData.orgType && (formData.orgType = formData.orgType.join(','));
    // formData.proField && (formData.proField = formData.proField.join(','));
    if (formData.proField && formData.proField.indexOf('custom') > -1) {
      /* if (
                    formData.proField[formData.proField.length - 1].indexOf('custom') > -1
                  ) {
                    formData.proField[
                      formData.proField.length - 1
                    ] = `custom_${orgFieldValue}`;
                  }
                  formData.proField = formData.proField.join(',');*/
      formData.proField = orgFieldValue;
    }
    formData.orgCategory && (formData.orgCategory = formData.orgCategory.join(','));


    formData.businessPlanUrl = businessPlanUrl;
    formData.otherMaterialsUrl = otherMaterialsUrl;
    formData.commitUrl = commitUrl;
    formData.patentLicenseUrl = patentLicenseUrl;
    formData.orgLicenseUrl = orgLicenseUrl;
    formData.id = detail && (detail as any).id;
    //console.log("formData", formData);
    const finalData = Object.assign(detail || {}, formData);
    console.log('finalData', finalData);
    const res = await apiFactory.techService.postRegistrationForm(formData).catch((error) => {
      message.error('提交失败 ' + error.data.message);
    });
    console.log(555, res);
    
    if (!res) {
      return;
    }
    
    if (res.status && res.status === 401) {
      message.error('用户未登录，请先登录');
      return;
    } else if (res.status && res.status != 200) {
      message.error(res.message || '提交错误');
      return;
    }

    message.success('提交成功');
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  return (
    <div className='home'>
      <>
        {(availableStatus === -1 && !detail) || status > -1 ? (
          <Result
            status={resultIcon as any}
            title={errorMsg}
            subTitle=''
            extra={[
              status === 1 ? (
                <Button type='primary' key='console' onClick={() => setStatus(-1)}>
                  重新编辑
                </Button>
              ) : (
                <>
                  <p></p>
                </>
              ),
              // status === 0 ? (
              //   <div>
              //     <img src={qrImg} />
              //   </div>
              // ) : (
              //   <></>
              // ),
            ]}
          />
        ) : (
          <>
            <div className='subTitle-zh' style={{ marginBottom: '48px' }}>
              1. 基本情况
            </div>

            <Form
              name='complex-form'
              form={form}
              onFinish={onFinish}
              labelWrap
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 21 }}
              style={{ marginBottom: '68px' }}
            >
              <Form.List
                name='orgName'
                initialValue={['']}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        return Promise.reject(new Error('At least 1 passengers'));
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item {...formItemLayout} extra={index === 0 ? '*第一单位默认为牵头单位' : ''} required={false} key={field.key}>
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: '单位名称不能为空',
                            },
                          ]}
                          noStyle
                        >
                          <Input placeholder='参赛单位名称' style={{ width: '60%' }} />
                        </Form.Item>
                        {fields.length > 1 ? <MinusCircleOutlined className='dynamic-delete-button' onClick={() => remove(field.name)} /> : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button type='dashed' disabled={fields.length === 2} onClick={() => add()} style={{ width: '60%' }} icon={<PlusOutlined />}>
                        添加参赛单位
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              <Form.Item
                name='orgType'
                label='单位类型（多选） ：'
                labelAlign='left'
                rules={[
                  {
                    required: true,
                    message: '单位类型不能为空',
                  },
                ]}
              >
                <Checkbox.Group onChange={(val) => {
                    console.log(111,val);
                    // if(val) {
                    //     setIsTeacher(val.indexOf('在读本硕博学生团队') !== -1);
                    // }
                }}>
                  <Row>
                    <Checkbox value='高校'>高校</Checkbox>
                    <Checkbox value='科研院所'>科研院所</Checkbox>
                    <Checkbox value='企业'>企业</Checkbox>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                name='regions'
                label='所属地区:'
                labelAlign='left'
                rules={[
                  {
                    required: true,
                    message: '请选择所属区县',
                  },
                ]}
              >
                 <Cascader style={{width: 500}}  options={
                    areaOptions
                 } onChange={(val) => {
                 }} placeholder="请选择所属区县" />
              </Form.Item>

              <Form.Item
                name='worksName'
                validateTrigger={['onChange', 'onBlur']}
                label='参赛项目名称:'
                labelAlign='left'
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: '参赛项目名称不能为空',
                  },
                ]}
              >
                <Input style={{ width: 500 }} />
              </Form.Item>

              <div style={{ width: '100%' }}>
                <Form.Item
                  label='参赛核心专利信息:'
                  labelAlign='left'
                ></Form.Item>     
                <div style={{ width: '100%', display: 'flex', marginBottom: 1 }}>
                  <Form.Item
                    name={'patentNo'}
                    validateTrigger={['onChange', 'onBlur']}
                    style={{ display: 'inline-block', width: 300 }}
                    rules={[{ required: true, message: '核心专利号不能为空' }]}
                  >
                    <Input placeholder='核心专利号' />
                  </Form.Item>
                  <Form.Item
                    name={'patentName'}
                    validateTrigger={['onChange', 'onBlur']}  
                    style={{ display: 'inline-block', width: 300 }}
                    rules={[{ required: true, message: '核心专利名称不能为空' }]}
                  >
                    <Input placeholder='核心专利名称' />
                  </Form.Item>
                  <Form.Item
                    name={'patentApplyDate'}
                    validateTrigger={['onChange', 'onBlur']}
                    style={{ display: 'inline-block', width: 300 }}
                    rules={[{ required: true, message: '申请日期不能为空' }]}
                  >
                      <DatePicker style={{width: '100%'}} placeholder='申请日期'/>
                  </Form.Item>
                  <Form.Item
                      name={'patentValidYear'}
                      validateTrigger={['onChange', 'onBlur']}
                      style={{ display: 'inline-block', width: 300 }}
                      rules={[{ required: true, message: '专利剩余有效年限不能为空' }]}
                    >
                      <InputNumber min={0} style={{ width: '100%' }} placeholder='专利剩余有效年限' />
                  </Form.Item>
                </div>
                
                <div>
                  <Form.Item
                    name={'patentType'}
                    validateTrigger={['onChange', 'onBlur']}
                    label='专利类型:'
                    labelAlign='left'
                    rules={[{ required: true, message: '专利类型不能为空' }]}
                  >
                    <Radio.Group style={{ width: 600 }}>
                      <Row>
                        <Radio value='发明'>发明</Radio>
                        <Radio value='实用新型'>实用新型</Radio>
                        <Radio value='外观设计'>外观设计</Radio>
                      </Row>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name={'applyPct'}
                    label='是否申请PCT:'
                    labelAlign='left'
                    rules={[
                      {
                        required: true,
                        message: '是否申请PCT不能为空',
                      },
                    ]}
                  >
                    <Radio.Group style={{ width: 600 }}>
                      <Row>
                        <Radio value='是（含正在申请）'>是（含正在申请）</Radio>
                        <Radio value='否'>否</Radio>
                        <Radio value='计划申请'>计划申请</Radio>
                      </Row>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>


              <Form.List
                name='patents'
                initialValue={[{}]}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        message.error('至少一条支撑专利信息');
                        return Promise.reject(new Error('至少一条支撑专利信息'));
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div
                      key={`zl_${key}`}
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: fields.length - 1 !== name ? 25 : 5,
                        borderBottom: fields.length - 1 !== name ? '1px dashed #d9d9d9' : '',
                      }}
                      >
                        <div style={{ width: '100%' }}>
                          <Form.Item
                            label={'支撑专利信息'+(key+1)+':'}
                            labelAlign='left'
                            labelCol={{span: 6}}
                          ></Form.Item>  
                          <div style={{ width: '100%', display: 'flex', marginBottom: 1 }}>
                            <Form.Item
                              {...restField}
                              name={[name, 'no']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '专利号不能为空' }]}
                            >
                              <Input placeholder='专利号' />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'name']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '专利名称不能为空' }]}
                            >
                              <Input placeholder='专利名称' />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'applyDate']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '申请日期不能为空' }]}
                            >
                              <DatePicker style={{width: '100%'}} placeholder='申请日期'/>
                            </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, 'validYear']}
                                style={{ display: 'inline-block', width: 300 }}
                                rules={[{ required: true, message: '专利剩余有效年限' }]}
                              >
                              <InputNumber min={0} style={{ width: '100%' }} placeholder='专利剩余有效年限' />
                            </Form.Item>
                          </div>

                          <div>
                            <Form.Item
                              {...restField}
                              name={[name, 'type']}
                              label='专利类型'
                              labelAlign='left'
                              rules={[{ required: true, message: '专利类型不能为空' }]}
                            >
                              <Radio.Group style={{ width: 600 }}>
                                <Row>
                                  <Radio value='发明'>发明</Radio>
                                  <Radio value='实用新型'>实用新型</Radio>
                                  <Radio value='外观设计'>外观设计</Radio>
                                </Row>
                              </Radio.Group>
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'applyPct']}
                              label='是否申请PCT'
                              labelAlign='left'
                              rules={[
                                {
                                  required: true,
                                  message: '是否申请PCT不能为空',
                                },
                              ]}
                            >
                              <Radio.Group style={{ width: 600 }}>
                                <Row>
                                  <Radio value='是（含正在申请）'>是（含正在申请）</Radio>
                                  <Radio value='否'>否</Radio>
                                  <Radio value='计划申请'>计划申请</Radio>
                                </Row>
                              </Radio.Group>
                            </Form.Item>
                          </div>
                        </div>
                        {fields.length > 1 && <MinusCircleOutlined onClick={() => patentRemove(key)} />}
                      </div>
                    ))}
                    <Form.Item>
                      <Button type='dashed' disabled={fields.length === 9} onClick={() => add()} style={{ width: '60%' }} icon={<PlusOutlined />}>
                        添加支撑专利
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              {/*tel row*/}
              <div style={{fontSize: '18px',color: 'rgba(0,0,0,0.85)',marginBottom: '20px'}}><span style={{color: 'red'}}>*&nbsp;</span>项目联系人信息：</div>  
              <Form.Item style={{ marginBottom: 0, marginTop: '20px' }}>
                <Form.Item
                  name='contactUser'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '姓名不能为空',
                    },
                  ]}
                  style={{ display: 'inline-block', width: 240 }}
                >
                  <Input placeholder='姓名' />
                </Form.Item>
                <Form.Item
                  name='contactPhone'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '电话不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 240,
                    margin: '0 8px',
                  }}
                >
                  <Input placeholder='电话' />
                </Form.Item>
                <Form.Item
                  name='contactPost'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '单位及职务不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 240,
                    margin: '0 8px',
                  }}
                >
                  <Input placeholder='单位及职务' />
                  </Form.Item>
                  
              </Form.Item>
                
              <Form.Item style={{ marginBottom: 0, marginTop: '20px' }}>
                <Form.Item
                  name='wechat'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '微信号不能为空',
                    },
                  ]}
                  style={{ display: 'inline-block', width: 240 }}
                >
                  <Input placeholder='微信号' />
                </Form.Item>
                <Form.Item
                  name='email'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '邮箱不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 240,
                    margin: '0 8px',
                  }}
                >
                  <Input placeholder='邮箱' />
                  </Form.Item>
                  
                </Form.Item>
                
                <div style={{fontSize: '18px',color: 'rgba(0,0,0,0.85)',marginBottom: '20px'}}><span style={{color: 'red'}}>*&nbsp;</span>团队负责人信息：</div>
                <div style={{ width: '100%', display: 'flex', marginBottom: 1 }}>
                <Form.Item
                  name='director'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '负责人不能为空',
                    },
                  ]}
                  style={{ display: 'inline-block', width: 300 }}
                >
                  <Input placeholder='负责人' />
                  </Form.Item>
                <Form.Item
                  name='directorAge'
                  style={{ display: 'inline-block', width: 300 }}
                  rules={[{ required: true, message: '负责人年龄不能为空' }]}
                >
                  <Input placeholder='负责人年龄' />
                </Form.Item>
                <Form.Item
                  name='directorPost'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '负责人单位及职务不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 300,
                    margin: '0 8px',
                  }}
                >
                  <Input placeholder='负责人单位及职务' />
                  </Form.Item>
                <Form.Item
                  name='directorPhone'
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: '负责人电话不能为空',
                    },
                  ]}
                  style={{
                    display: 'inline-block',
                    width: 300,
                    margin: '0 8px',
                  }}
                >
                  <Input placeholder='负责人电话' />
                </Form.Item>
                  
                </div>
              
              <div style={{fontSize: '18px',color: 'rgba(0,0,0,0.85)',marginBottom: '20px'}}><span style={{color: 'red'}}>*&nbsp;</span>团队其他项目成员信息：</div>  
              <Form.List
                name='team'
                initialValue={[{}]}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        return Promise.reject(new Error('At least 1 passengers'));
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div
                        key={`cy_${key}`}
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: fields.length - 1 !== name ? 25 : 5,
                          borderBottom: fields.length - 1 !== name ? '1px dashed #d9d9d9' : '',
                        }}
                      >
                        <div style={{ width: '100%' }}>
                          <div style={{ width: '100%', display: 'flex', marginBottom: 1 }}>
                            <Form.Item
                              {...restField}
                              name={[name, 'name']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '姓名不能为空' }]}
                            >
                              <Input placeholder='姓名' />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'age']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '年龄不能为空' }]}
                            >
                              <Input placeholder='年龄' />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, 'post']}
                              style={{ display: 'inline-block', width: 300 }}
                              rules={[{ required: true, message: '单位及职务' }]}
                            >
                              <Input placeholder='单位及职务' />
                            </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, 'phone']}
                                style={{ display: 'inline-block', width: 300 }}
                                rules={[{ required: true, message: '电话不能为空' }]}
                              >
                                <Input placeholder='电话' />
                            </Form.Item>
                          </div>
                        </div>
                        {fields.length > 1 && <MinusCircleOutlined onClick={() => remove(name)} />}
                      </div>
                    ))}
                    <Form.Item>
                      <Button type='dashed' onClick={() => add()} style={{ width: '60%' }} icon={<PlusOutlined />}>
                        添加项目成员信息
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <Form.Item
                name='proField'
                label='项目领域:'
                labelAlign='left'
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: '项目领域不能为空',
                  },
                ]}
              >
                <Radio.Group onChange={changeCustomInput}>
                  <Row>
                    <Radio value='数字经济'>数字经济</Radio>
                    <Radio value='生物经济'>生物经济</Radio>
                    <Radio value='冰雪经济'>冰雪经济</Radio>
                    <Radio value='创意设计'>创意设计</Radio>
                    <Radio value='航空航天'>航空航天</Radio>
                    <Radio value='电子信息'>电子信息</Radio>
                    <Radio value='新材料'>新材料</Radio>
                    <Radio value='高端装备'>高端装备</Radio>
                    <Radio value='农机装备'>农机装备</Radio>
                    <Radio value='能源'>能源</Radio>
                    <Radio value='化工'>化工</Radio>
                    <Radio value='食品'>食品</Radio>
                    <Radio value='医药'>医药</Radio>
                    <Radio value='custom'>
                      <Input
                        disabled={customInputState}
                        style={{ width: 140 }}
                        placeholder='其他'
                        value={orgFieldValue}
                        onChange={(e) => setOrgFieldValue(e.target.value)}
                      />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name='isOpen'
                label='专利开放许可意愿:'
                labelAlign='left'
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '专利开放许可意愿不能为空',
                  },
                ]}
              >
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name='roadshow'
                label='项目路演及投融资意愿:'
                labelAlign='left'
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '项目路演及投融资意愿不能为空',
                  },
                ]}
              >
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name='techTransfer'
                label='技术转化及交易意愿:'
                labelAlign='left'
                style={{ marginTop: '55px' }}
                rules={[
                  {
                    required: true,
                    message: '技术转化及交易意愿不能为空',
                  },
                ]}
              >
                <Radio.Group>
                  <Row>
                    <Radio value={true} style={{ lineHeight: '32px' }}>
                      愿意
                    </Radio>
                    <Radio value={false} style={{ lineHeight: '32px' }}>
                      暂不考虑
                    </Radio>
                  </Row>
                </Radio.Group>
              </Form.Item>
    
              <div className='subTitle-zh' style={{ marginTop: '68px', marginBottom: '40px' }}>
                2. 项目信息
              </div>

              <div className='subTitle' style={{ marginTop: '50px' }}>
                2.1 参赛项目/专利（包）基本情况
              </div>

              <Row gutter={[16, 16]} style={{ marginTop: '25px' }}>
                <Col span={'24'}>
                  <label className='form-label'><span style={{color: 'red'}}>*</span>技术情况：简要介绍技术情况并简要说明在同类技术中的优势。</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'24'}>
                  <Form.Item name='techInfo' 
                    rules={[
                        {
                            validator: async(_,names)=>{
                                if(uploaded){
                                    return Promise.resolve();
                                }
                                if((names && names.trim().length<10) || !names){
                                    return Promise.reject(new Error('请输入至少10个字符'))
                                }
                            }   
                        },
                      ]}
                  >
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
              </Row>

              {/* row 2*/}

              <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className='form-label'><span style={{color: 'red'}}>*</span>团队情况：简要介绍项目技术带头人/核心团队成员情况。</label>
                  </Col>
                  <Col span={'11'} offset={1}>
                  <label className='form-label'><span style={{color: 'red'}}>*</span>市场化运营：简要介绍市场需求与定位情况、专利实施转化情况、预期产生的效益、市场前景、发展潜力、商业模式等</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item name='teamInfo'
                    rules={[
                        {
                            validator: async(_,names)=>{
                                if(uploaded){
                                    return Promise.resolve();
                                }
                                if((names && names.trim().length<10) || !names){
                                    return Promise.reject(new Error('请输入至少10个字符'))
                                }
                            }   
                        },
                      ]}
                  >
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
                <Col span={'11'} offset={1}>
                  <Form.Item name='marketInfo'
                    rules={[
                        {
                            validator: async(_,names)=>{
                                if(uploaded){
                                    return Promise.resolve();
                                }
                                if((names && names.trim().length<10) || !names){
                                    return Promise.reject(new Error('请输入至少10个字符'))
                                }
                            }   
                        },
                      ]}
                  >
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
                </Row>
                
                <Row gutter={[16, 16]}>
                <Col span={'11'}>
                  <label className='form-label'><span style={{color: 'red'}}>*</span>专利培育布局：请说明在专利培育、布局和保护上做了哪些工作，例如专利组合、海外申请、标准相关性、产品关联度、针对竞争对手的布局等，培育布局过程中的规范性、创新方法等</label>
                  </Col>
                  <Col span={'11'} offset={1}>
                  <label className='form-label'><span style={{color: 'red'}}>*</span>社会效益：简要介绍对社会发展的贡献、行业发展及技术趋势的预期影响、政策适应性</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item name='patentLayoutInfo'
                    rules={[
                        {
                            validator: async(_,names)=>{
                                if(uploaded){
                                    return Promise.resolve();
                                }
                                if((names && names.trim().length<10) || !names){
                                    return Promise.reject(new Error('请输入至少10个字符'))
                                }
                            }   
                        },
                      ]}
                  >
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
                <Col span={'11'} offset={1}>
                  <Form.Item name='socialImpactInfo'
                    rules={[
                        {
                            validator: async(_,names)=>{
                                if(uploaded){
                                    return Promise.resolve();
                                }
                                if((names && names.trim().length<10) || !names){
                                    return Promise.reject(new Error('请输入至少10个字符'))
                                }
                            }   
                        },
                      ]}
                  >
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
              </Row>

              <div className='subTitle' style={{ marginTop: '50px' }}>
                2.2 专利转化和布局情况/专利技术成果转化计划
              </div>
              <Form.Item name='isLanding' label='是否有落地意愿' labelAlign='left' style={{ marginTop: '25px' }}
                rules={[
                    {
                      required: true,
                      message: '请选择',
                    },
                  ]}
              >
                <Radio.Group
                  
                  onChange={(e) => {
                    setConvertState(e.target.value);
                  }}
                >
                  <Radio value={true} style={{ color: '#034ea2' }}>
                    是
                  </Radio>
                  <Radio value={false} style={{ color: '#034ea2' }}>
                    否
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <label className='form-label'>落地需求：（若有落地意愿，请详细说明具体需求有哪些？比如政策、资金、场地、区域等资源支持）</label>
                </Col>
                <Col span={'11'} offset={1}>
                  <label className='form-label'>融资需求：（如有融资需求，请列出截止目前的融资情况以及本次的融资需求）</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item name='landingDemandInfo'>
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
                <Col span={'11'} offset={1}>
                  <Form.Item name='financingDemandInfo'>
                    <Input.TextArea rows={4} />
                  </Form.Item>
                </Col>
              </Row>
                
              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <label className='form-label'>其他：（在媒体宣传、专利培训、参加展会等方面的需求等）</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item name='otherInfo'>
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
              </Row>

              {/* row 5*/}
              <div className='subTitle' style={{ marginTop: '50px' }}>
                2.3 获奖状况
              </div>
              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <label className='form-label'>（如有，没有可不填写）</label>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '15px' }}>
                <Col span={'11'}>
                  <Form.Item name='awardInfo'>
                    <Input.TextArea rows={4}  />
                  </Form.Item>
                </Col>
                </Row>
                
              <Form.Item name='otherMaterialsUrl'>
                <Upload
                  name='logo'
                  multiple
                  maxCount={5}
                  customRequest={(opt) => {
                    handleUpload(opt, otherMaterialsUrl, setOtherMaterialsUrl, setMaterialDefaultFileList);
                  }}
                  beforeUpload={beforeUpload}
                  onRemove={(i) => {
                    // setBusinessPlanUrl('');
                    removeUploadFile(i, otherMaterialsUrl, setOtherMaterialsUrl);
                  }}
                  defaultFileList={materialDefaultFileList}
                >
                  <Button className='uploadButton' type='default'>
                    <div>上传补充资料 （可选）</div>
                    <div style={{ color: '#999999' }}>文件不大于50M</div>
                    <div style={{ color: '#999999' }}>支持PPT、PDF、PNG、JPG格式</div>
                  </Button>
                </Upload>
              </Form.Item>
              <p className='uploadTips'>* 补充资料可上传多个附件，最多为5个</p>
              <div style={{ display: 'inline-block' }}>
                <Form.Item name='businessPlanUrl'>
                  <Upload
                    name='logo'
                    multiple
                    maxCount={5}
                    customRequest={(opt) => {
                      handleUpload(opt, businessPlanUrl, setBusinessPlanUrl, setDefaultFileList);
                    }}  
                    beforeUpload={beforeUpload}
                    onRemove={(i) => {
                      // setBusinessPlanUrl('');
                      removeUploadFile(i, businessPlanUrl, setBusinessPlanUrl);
                    }}
                    defaultFileList={defaultFileList}
                  >
                    <Button className='uploadButton' type='default'>
                      <div>上传商业计划书/路演PPT （必填）</div>
                      <div style={{ color: '#999999' }}>文件不大于50M</div>
                      <div style={{ color: '#999999' }}>支持PPT、PDF格式</div>
                    </Button>
                  </Upload>
                </Form.Item>
                </div>
              <p className='uploadTips fontColor'>
                <div style={{ color: '#999999',fontSize:'14px' }}>如参赛单位为多个，请上传所有参赛单位证照扫描件，单个文件大小在50M之内</div>
              </p>
              <Form.Item name='orgLicenseUrl'>
                <Upload
                  name='logo'
                  multiple
                  maxCount={5}
                  customRequest={(opt) => {
                    handleUpload(opt, orgLicenseUrl, setOrgLicenseUrl, setOrgLicenseDefaultFileList);
                  }}
                  beforeUpload={beforeUpload}
                  onRemove={(i) => {
                    // setBusinessPlanUrl('');
                    removeUploadFile(i, orgLicenseUrl, setOrgLicenseUrl);
                  }}
                  defaultFileList={orgLicenseDefaultFileList}
                >
                  <Button className='uploadButton' type='default'>
                    <div>参赛主体证照（可选）</div>
                    <div style={{ color: '#999999' }}>如参赛主体为企业必须上传<br/>高校院所无需上传</div>
                  </Button>
                </Upload>
              </Form.Item>

              <Form.Item name='patentLicenseUrl'>
                <Upload
                  name='logo'
                  multiple
                  maxCount={5}
                  customRequest={(opt) => {
                    handleUpload(opt, patentLicenseUrl, setPatentLicenseUrl, setPatentLicenseDefaultFileList);
                  }}
                  beforeUpload={beforeUpload}
                  onRemove={(i) => {
                    // setBusinessPlanUrl('');
                    removeUploadFile(i, patentLicenseUrl, setPatentLicenseUrl);
                  }}
                  defaultFileList={patentLicenseDefaultFileList}
                >
                  <Button className='uploadButton' type='default'>
                      <div>专利证书（必填）</div>
                      <div style={{ color: '#999999' }}>核心专利及专利组合</div>
                  </Button>
                </Upload>
              </Form.Item>

              <p className='uploadTips fontColor'>
                <a href={process.env.PUBLIC_URL + '/college/参赛承诺书模版.docx'}>下载参赛承诺书模板</a>{' '}<div style={{ color: '#999999',fontSize:'14px' }}>（下载承诺书模版）承诺书由项目负责人签署，高校/院所参赛项目需加盖学校/院所公章；企业参赛项目需加盖企业公章</div>
              </p>
              <Form.Item name='commitUrl'>
                <Upload
                  name='logo'
                  multiple
                  maxCount={5}
                  customRequest={(opt) => {
                    handleUpload(opt, commitUrl, setCommitUrl, setCommitDefaultFileList);
                  }}
                  beforeUpload={beforeUpload}
                  onRemove={(i) => {
                    // setBusinessPlanUrl('');
                    removeUploadFile(i, commitUrl, setCommitUrl);
                  }}
                  defaultFileList={commitDefaultFileList}
                >
                  <Button className='uploadButton' type='default'>
                      <div>参赛承诺书 （必填）</div>
                  </Button>
                </Upload>
              </Form.Item>
              <br />
              <br />
              <button
                type='button'
                onClick={submitForm}
                className='blueButton'
                style={{ marginTop: '35px', marginBottom: '50px' }}
              >
                提交报名信息
              </button>
            </Form>
          </>
        )}
      </>
    </div>
  );
};

export default College;
